/**
 * Formats a date string or object into "DD MMM YYYY" format
 * Example: "2026-03-25" -> "25 Mar 2026"
 */
export const formatDate = (dateValue) => {
  if (!dateValue) return "N/A";
  
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return dateValue;

  const day = String(date.getDate()).padStart(2, "0");
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

/**
 * Formats a number as currency with symbol and thousand separators
 * Example: 10000, "INR" -> "₹ 10,000"
 */
export const formatRevenue = (amount, currency = "INR") => {
  if (amount === undefined || amount === null) return "0";

  const symbols = {
    INR: "₹",
    AED: "AED",
    USD: "$",
    EUR: "€",
    GBP: "£",
  };

  const symbol = symbols[currency] || currency;
  const formattedAmount = Number(amount).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return `${symbol} ${formattedAmount}`;
};
